angular.module('gym.contacts').factory('ContactWalletService', ["$modal", "MasqueradingService", function($modal, MasqueradingService) {
  var ContactWalletService;
  ContactWalletService = {
    getDefaultPaymentMethod: function(paymentMethods) {
      var pm;
      pm = _.filter(paymentMethods, function(item) {
        return item != null ? item.last4 : void 0;
      });
      if (!pm.length) {
        return void 0;
      }
      if (pm.length === 1) {
        return pm[0];
      }
      return _.find(pm, function(paymentMethod) {
        return paymentMethod.default;
      });
    },
    confirmRemovePaymentMethod: function(paymentMethod) {
      var modalInstance;
      modalInstance = $modal.open({
        template: require('templates/gyms/contacts/payment_details/confirm_remove_payment_method.html.slim'),
        controller: ["$scope", "$modalInstance", function($scope, $modalInstance) {
          $scope.allowResetCustomer = MasqueradingService.isMasquerading() && paymentMethod.route === 'ezidebit';
          $scope.paymentMethod = paymentMethod;
          $scope.params = {
            reset_customer_ref: false
          };
          $scope.submit = function() {
            return $modalInstance.close($scope.params);
          };
          return $scope.cancel = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
      return modalInstance.result;
    }
  };
  return ContactWalletService;
}]);
